export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const SET_SELECTED_COURSE_TYPE = 'SET_SELECTED_COURSE_TYPE';
export const SET_SUB_SELECTED_COURSE_TYPE = 'SET_SUB_SELECTED_COURSE_TYPE';
export const GET_QUESTION_LIST_SUCCESS = 'GET_QUESTION_LIST_SUCCESS';
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export const UPDATE_QUESTION_HTML_SUCCESS = 'UPDATE_QUESTION_HTML_SUCCESS';
export const SAVE_QUESTION_RANGY_MARK = 'SAVE_QUESTION_RANGY_MARK';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const MARK_QUESTION_SUCCESS = 'MARK_QUESTION_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = 'Loading ...';
export const GET_BEFORE_MOCK_SUCCESS = 'GET_BEFORE_MOCK_SUCCESS';
export const REDO_MOCK = 'REDO_MOCK';
export const GET_AFTER_MOCK_SUCCESS = 'GET_AFTER_MOCK_SUCCESS';
export const SET_QUESTION = 'SET_QUESTION';
export const SET_EVENT_STATUS = 'SET_EVENT_STATUS';
export const QUESTION_SUBMITTED_SUCCESS = 'QUESTION_SUBMITTED_SUCCESS';
